import { ProductCharacteristic } from "@/@types";

type ProductProps = {
    features: ProductCharacteristic[]
};

export default function ProductTabSpec({ features }: ProductProps) {
    return (
        <ul className="grid sm:grid-cols-2 grid-cols-1 text-sm text-gray-600">
            {features.map((item, index) => (
                item.rubroName === "Nota" ? (
                    // Manteniendo el diseño en 2 columnas con la estructura que enviaste
                    <li key={index} className="border-b pl-4 pr-4 pt-2 pb-2 gap-4">
                        <ul className="flex flex-col">
                            <li>
                                <span className="font-medium">{item.rubroName}</span>
                            </li>
                            <li>
                                <p className="text-gray-800">{item.value ?? "N/A"}</p>
                            </li>
                        </ul>
                    </li>
                ) : (
                    // Características normales en dos columnas
                    <li key={index} className="border-b  grid grid-cols-2 pl-4 pr-4 pt-2 pb-2 gap-4 items-center">
                        <span className="font-medium">{item.rubroName}</span>
                        <span className={`text-gray-800 text-right ${item.unitType && item.unitType === "text" ? "" : "font-bold"}`}>
                            {item.value ?? "N/A"} {item.unit ?? ""}
                        </span>
                    </li>
                )
            ))}
        </ul>
    )
}
